import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslationModule } from '../../../i18n/translation-module';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { Router } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { take } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { COMPANY_PROFILE_CARD_DATA_TOKEN } from '../../../tokens-and-interfaces';
import { businessAccountLink, SNACKBAR_DURATION } from '../../../constants';
import { CompanyProfileCardsPanelService } from '../../../shared-services/company-profile-cards-panel.service';

@Component({
  selector: 'crm-campaigns-card',
  standalone: true,
  imports: [
    CommonModule,
    TranslationModule,
    MatExpansionModule,
    MatInputModule,
    GalaxyFormFieldModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './company-campaigns-card.component.html',
  styleUrls: ['./company-campaigns-card.component.scss', '../../../shared-styles/association-panel-shared.scss'],
})
export class CompanyCampaignsCardComponent {
  loadingAccountGroup = signal(false);
  data = inject(COMPANY_PROFILE_CARD_DATA_TOKEN);

  constructor(
    private router: Router,
    private snackbarService: SnackbarService,
    private companyProfileCardService: CompanyProfileCardsPanelService,
  ) {}

  viewCampaigns() {
    if (this.data.account_group_id) {
      this.navigateToCampaigns(this.data.account_group_id);
      return;
    }
    this.loadingAccountGroup.set(true);
    this.companyProfileCardService
      .createAccountGroupForCompany(this.data.company_id)
      .pipe(take(1))
      .subscribe({
        next: (accountGroupId) => {
          if (accountGroupId.length > 0) {
            this.navigateToCampaigns(accountGroupId);
          }
          this.loadingAccountGroup.set(false);
        },
        error: () => {
          this.snackbarService.openErrorSnack('ASSOCIATIONS.COMPANY.ERROR', {
            duration: SNACKBAR_DURATION,
          });
          this.loadingAccountGroup.set(false);
        },
      });
  }

  navigateToCampaigns(accountGroupId: string) {
    this.router.navigateByUrl(businessAccountLink.replace('%s', accountGroupId));
  }
}
